<template>
  <div class="" v-if="list">
    <board-filter @onSearch="onSearch"/>
    <div class="strTablescr">
     <div class="strTablePC">
        <table class="strTablePT">
          <colgroup>
            <col width="5%">
            <col width="7%">
            <col width="10%">
            <col width="10%">
            <col width="40%">
            <col width="20%">
            <col width="8%">
          </colgroup>
          <thead>
            <tr>
              <th><input type="checkbox" v-model="isAllCheck"/></th>
              <th>{{$t('front.board.check')}}</th>
              <th>{{$t('front.board.status')}}</th>
              <th>{{$t('front.board.type')}}</th>
              <th>{{$t('front.board.title')}}</th>
              <th>{{$t('front.board.regDate')}}</th>
              <th>{{$t('front.board.delete')}}</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="list.length > 0">
              <template v-for="item in list" :key="item.boardIdx">
                <tr>
                  <td><input type="checkbox" v-model="item.checked"/></td>
                  <td><span class="ocmsg" :class="item.isReadAdmin === 'Y' ? 'openmsg': 'closemsg'"></span></td>
                  <td>
                     <span v-if="item.status === 'ANSWER'" class="nbicon bkblbg">{{$t('front.qnaStatus.answer')}}</span>
                     <span v-if="item.status === 'WAIT'" class="nbicon bkblbg">{{$t('front.qnaStatus.wait')}}</span>
                  </td>
                  <td>{{$t('front.qnaTypeCategory.' + item.faqType)}}</td>
                  <td @click.prevent="onClickRead(item.boardIdx)">
                     <a href="#" >
                        {{item.title}}
                        <span class="newicon rdbg ml5">N</span>
                     </a>
                  </td>
                  <td>{{dateFormatForBoard(item.regDate)}}</td>
                  <td><span class="nbicon bgrbg" @click.prevent="onClickRemove(item.boardIdx)" style="cursor: pointer">{{$t('front.board.delete')}}</span></td>
                </tr>
              </template>
            </template>
            <template v-else>
              <tr>
                 {{$t('front.board.noAsk')}}
              </tr>
            </template>
          </tbody>
        </table>
     </div>
     <!-- <div class="strTableM">
        <div class="strTablePTM">
           <template v-if="list.length > 0">
             <template v-for="item in list" :key="item.boardIdx">
               <ul>
                 <li><input type="checkbox" /></li>
                 <li>
                    <em>{{$t('front.board.check')}}</em>
                    <span class="ocmsg" :class="item.isReadAdmin === 'Y' ? 'openmsg': 'closemsg'"></span>
                 </li>
                 <li>
                    <em>{{$t('front.board.status')}}</em>
                    <span v-if="item.status === 'ANSWER'" class="blc nbicon wtblbg">{{$t('front.qnaStatus.answer')}}</span>
                    <span v-if="item.status === 'WAIT'" class="nbicon bkblbg">{{$t('front.qnaStatus.wait')}}</span>
                 </li>
                 <li>
                    <em>{{$t('front.board.type')}}</em>
                    {{$t('front.qnaTypeCategory.' + item.faqType)}}
                 </li>
                 <li @click.prevent="onClickRead(item.boardIdx)">
                    <em>{{$t('front.board.title')}}</em>
                    <a href="#" >
                      {{item.title}}
                      <span class="newicon rdbg ml5">N</span>
                    </a>
                 </li>
                 <li>
                    <em>{{$t('front.board.regDate')}}</em>
                    {{dateFormatForBoard(item.regDate)}}
                 </li>
                 <li>
                    <em>{{$t('front.board.delete')}}</em>
                    <span class="nbicon bgrbg" @click.prevent="onClickRemove(item.boardIdx)">{{$t('front.board.delete')}}</span>
                 </li>
               </ul>
             </template>
           </template>
           <template v-else>
             <ul>
                <li>{{$t('front.common.notFoundList')}}</li>
             </ul>
           </template>
        </div>
     </div> -->
  </div>

    <div class="applibtns">
      <a @click="getAcc">{{$t('front.board.bankAccountQna')}}</a>
      <a @click="onClickWrite">{{$t('front.board.qnaWrite')}}</a>
      <a @click="onCheckedDelete">선택 삭제</a>
    </div>

    <pagination :pageNum="pageInfo.page"
                :pageSize="pageInfo.count_per_list"
                :totalCount="pageInfo.tatal_list_count"
                @goToPage="loadList()"/>

  </div>

</template>

<script>
import Pagination from '@/components/ui/Pagination'
import BoardFilter from '@/components/common/BoardFilter'
import { mapState } from 'vuex'
import { saveBoard } from '@/api/board'

export default {
  name: 'qna',
  components: {
    BoardFilter,
    Pagination
  },
  data () {
    return {
      list: null,
      boardType: 'faq',
      searchParam: {
        searchOption: '',
        searchValue: ''
      },
      idxList: [],
      category: '',
      isAllCheck: false
    }
  },
  async created () {
    await this.loadList()
  },
  computed: {
    ...mapState([
      'userData'
    ])
  },
  watch: {
    isAllCheck () {
      this.list.forEach(item => {
        item.checked = this.isAllCheck
      })
    }
  },
  methods: {
    async onCheckedDelete () {
      const checkedList = this.list.filter(item => {
        return item.checked
      })

      if (checkedList.length > 0) {
        const confirm = await this.onConfirm('선택한 게시물을 삭제하시겠습니까?')
        if (confirm) {
          for (let i = 0; i < checkedList.length; i++) {
            const item = checkedList[i]
            const params = {
              boardIdx: item.boardIdx,
              boardType: this.boardType,
              delYn: 'Y',
              memId: this.userData.memId,
              memName: this.userData.memName
            }

            await saveBoard(params).then(res => {
              return true
            })
          }
          await this.loadList()
        }
      }
    },
    async getAcc () {
      const title = '계좌문의입니다.'
      const content = '계좌문의입니다.'
      const params = {
        title: title,
        content: content,
        boardType: 'faq',
        category: '',
        faqType: 'bankaccount'
      }

      await this.setSaveAccountBoard(params, async function () {
        await this.loadList()
      }.bind(this))
    },
    onCategoryChange (category) {
      this.category = category
      this.loadList()
    },
    onSearch (value) {
      this.searchParam.searchOption = value.type
      this.searchParam.searchValue = value.text

      this.loadList()
    },
    async loadList () {
      const params = {
        boardType: this.boardType,
        category: this.category,
        memId: this.userData.memId
      }

      const searchValue = this.searchParam.searchValue
      if (searchValue) {
        params.searchOption = this.searchParam.searchOption
        params.searchValue = this.searchParam.searchValue
      }

      const result = await this.getBoardList(params, this.pageInfo.page)
      result.list.forEach(item => {
        item.checked = false
        item.isContentOpen = false
      })
      this.list = result.list
      this.idxList = result.idxList
    },
    onClickRead (id) {
      if (!id) id = 1
      this.$router.push({ name: 'qnaread', params: { boardIdx: id } })
    },
    onClickWrite () {
      this.$router.push({ name: 'qnaWrite' })
    },
    async onClickRemove (boardIdx) {
      if (boardIdx) {
        const params = {
          boardIdx: boardIdx,
          boardType: this.boardType,
          delYn: 'Y'
        }

        await this.setSaveBoard(params, 'delete', () => {
          this.loadList()
        })
      }
    }
  }
}
</script>
<style scoped>
a{color:#121212;}
</style>
<style src="@/styles/striNew.css"></style>
<style scoped>
.applibtns{gap:20px;}
@media (max-width: 1000px) {
  .strTablePTM li {width: 100%;gap: 10px;}
  .ocmsg {margin: 0;}
}
</style>

<style scoped>
/* 1:1 문의 목록 - 화이트 카드형 디자인 보정
   template/script 구조 변경 없이 현재 컴포넌트 내부 스타일만 보정 */

/* 검색 영역(BoardFilter) */
:deep(.boardFilter),
:deep(.board-filter),
:deep(.searchwrap),
:deep(.searchWrap),
:deep(.board-search),
:deep(.search-area),
:deep(.filter-wrap),
:deep(.boardw) {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  margin: 22px 0 18px !important;
  padding: 0 !important;
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
}

:deep(.boardFilter select),
:deep(.board-filter select),
:deep(.searchwrap select),
:deep(.searchWrap select),
:deep(.board-search select),
:deep(.search-area select),
:deep(.filter-wrap select),
:deep(.boardFilter input),
:deep(.board-filter input),
:deep(.searchwrap input),
:deep(.searchWrap input),
:deep(.board-search input),
:deep(.search-area input),
:deep(.filter-wrap input) {
  height: 32px !important;
  padding: 0 12px !important;
  border: 1px solid #d4ddeb !important;
  border-radius: 6px !important;
  background: #ffffff !important;
  color: #263244 !important;
  font-size: 13px !important;
  box-shadow: none !important;
  outline: none !important;
  box-sizing: border-box !important;
}

:deep(.boardFilter select),
:deep(.board-filter select),
:deep(.searchwrap select),
:deep(.searchWrap select),
:deep(.board-search select),
:deep(.search-area select),
:deep(.filter-wrap select) {
  min-width: 116px !important;
}

:deep(.boardFilter input[type="text"]),
:deep(.board-filter input[type="text"]),
:deep(.searchwrap input[type="text"]),
:deep(.searchWrap input[type="text"]),
:deep(.board-search input[type="text"]),
:deep(.search-area input[type="text"]),
:deep(.filter-wrap input[type="text"]) {
  width: 210px !important;
}

:deep(.boardFilter input::placeholder),
:deep(.board-filter input::placeholder),
:deep(.searchwrap input::placeholder),
:deep(.searchWrap input::placeholder),
:deep(.board-search input::placeholder),
:deep(.search-area input::placeholder),
:deep(.filter-wrap input::placeholder) {
  color: #9aa6b8 !important;
}

:deep(.boardFilter button),
:deep(.board-filter button),
:deep(.searchwrap button),
:deep(.searchWrap button),
:deep(.board-search button),
:deep(.search-area button),
:deep(.filter-wrap button) {
  height: 32px !important;
  min-width: 32px !important;
  padding: 0 10px !important;
  border: 0 !important;
  border-radius: 6px !important;
  background: #5ab8b5 !important;
  color: #ffffff !important;
  font-weight: 900 !important;
  box-shadow: 0 5px 10px rgba(90, 184, 181, 0.18) !important;
  cursor: pointer !important;
}

/* 테이블 카드 */
.strTablescr {
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: visible !important;
  background: transparent !important;
  border: 0 !important;
}

.strTablePC {
  width: 100% !important;
  overflow: hidden !important;
  border: 1px solid #dbe3ef !important;
  border-radius: 10px !important;
  background: #ffffff !important;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05) !important;
}

.strTablePT {
  width: 100% !important;
  border-collapse: collapse !important;
  table-layout: fixed !important;
  background: #ffffff !important;
  color: #1f2937 !important;
  font-size: 13px !important;
}

.strTablePT th,
.strTablePT td {
  height: 44px !important;
  padding: 9px 12px !important;
  border: 0 !important;
  border-bottom: 1px solid #dfe6ef !important;
  color: #1f2937 !important;
  text-align: center !important;
  vertical-align: middle !important;
  box-sizing: border-box !important;
}

.strTablePT th {
  height: 45px !important;
  background: #ffffff !important;
  color: #111827 !important;
  font-weight: 900 !important;
  border-bottom: 1px solid #cfd8e5 !important;
}

.strTablePC thead tr {
  border-top: 3px solid #2f6df6 !important;
}

.strTablePT tbody tr {
  background: #ffffff !important;
}

.strTablePT tbody tr:nth-child(2n) {
  background: #f7f8fa !important;
}

.strTablePT tbody tr:hover {
  background: #eef6ff !important;
}

.strTablePT tbody tr:last-child td {
  border-bottom: 0 !important;
}

.strTablePT td:nth-child(5) {
  text-align: center !important;
  padding-left: 18px !important;
  padding-right: 18px !important;
}

.strTablePT td:nth-child(5) a {
  color: #111827 !important;
  text-decoration: none !important;
}

.strTablePT td:nth-child(5) a:hover {
  color: #2563eb !important;
  text-decoration: underline !important;
}

.strTablePT input[type="checkbox"] {
  width: 14px !important;
  height: 14px !important;
  margin: 0 !important;
  accent-color: #2563eb !important;
}

.nbicon {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  min-width: 46px !important;
  height: 23px !important;
  padding: 0 8px !important;
  border-radius: 12px !important;
  font-size: 12px !important;
  font-weight: 800 !important;
  line-height: 1 !important;
  box-sizing: border-box !important;
}

.bkblbg {
  background: #0f68b7 !important;
  color: #ffffff !important;
}

.bgrbg {
  background: #3f3f46 !important;
  color: #ffffff !important;
}

.newicon {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  min-width: 14px !important;
  height: 14px !important;
  padding: 0 3px !important;
  border-radius: 2px !important;
  font-size: 10px !important;
  font-weight: 900 !important;
  line-height: 1 !important;
}

.rdbg {
  background: #ff174c !important;
  color: #ffffff !important;
}

.ocmsg {
  display: inline-block !important;
  width: 22px !important;
  height: 20px !important;
  margin: 0 !important;
  vertical-align: middle !important;
}

/* 하단 버튼 */
.applibtns {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 20px !important;
  margin: 66px 0 18px !important;
  padding: 0 !important;
}

.applibtns a {
  min-width: 150px !important;
  height: 34px !important;
  padding: 0 18px !important;
  border-radius: 4px !important;
  background: #5368d8 !important;
  color: #ffffff !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  line-height: 34px !important;
  text-align: center !important;
  text-decoration: none !important;
  box-shadow: 0 7px 14px rgba(83, 104, 216, 0.16) !important;
  cursor: pointer !important;
  box-sizing: border-box !important;
}

.applibtns a:hover {
  background: #3f55c5 !important;
}

:deep(.partnerPaging),
:deep(.paging),
:deep(.pagination) {
  margin-top: 14px !important;
}

/* 데이터 없을 때 tr 텍스트가 깨지는 원본 구조 보정 */
.strTablePT tbody > tr:only-child {
  height: 54px !important;
}

.strTablePT tbody > tr:only-child::after {
  content: '';
}

@media (max-width: 1000px) {
  :deep(.boardFilter),
  :deep(.board-filter),
  :deep(.searchwrap),
  :deep(.searchWrap),
  :deep(.board-search),
  :deep(.search-area),
  :deep(.filter-wrap) {
    flex-wrap: wrap !important;
    margin: 16px 0 14px !important;
  }

  :deep(.boardFilter input[type="text"]),
  :deep(.board-filter input[type="text"]),
  :deep(.searchwrap input[type="text"]),
  :deep(.searchWrap input[type="text"]),
  :deep(.board-search input[type="text"]),
  :deep(.search-area input[type="text"]),
  :deep(.filter-wrap input[type="text"]) {
    width: calc(100% - 44px) !important;
  }

  .strTablePC {
    overflow-x: auto !important;
  }

  .strTablePT {
    min-width: 860px !important;
  }

  .applibtns {
    gap: 8px !important;
    margin: 28px 0 14px !important;
  }

  .applibtns a {
    min-width: 0 !important;
    flex: 1 1 0 !important;
    padding: 0 8px !important;
    font-size: 13px !important;
  }
}
</style>
<style src="@/styles/mobile.css"></style>
